import { Component, Prop, h } from '@stencil/core';
import { Zone } from './area-interface';
import forOwn from 'lodash-es/forOwn';
import sortBy from 'lodash-es/sortBy';
import groupBy from 'lodash-es/groupBy';

@Component({
  tag: 'lar-area-zones',
  styleUrl: 'area.scss',
  shadow: true,
})
export class AreaZones {
  @Prop() zones: string;

  render() {
    const zones: any[] = [];
    const sortedZones = sortBy(JSON.parse(this.zones), 'group');
    const groupedZones = groupBy(sortedZones, 'group');
    forOwn(groupedZones, (groupedZonesOwn, group) => {
      zones.push(<lar-list-header><lar-translate t={group} /></lar-list-header>);
      sortBy(groupedZonesOwn, 'name').forEach(zone => {
        let color = 'success';
        if (zone.state === 'open') {
          color = 'tertiary';
        }
        if (zone.state === 'short_circuit') {
          color = 'warning';
        }
        if (zone.state === 'open_circuit') {
          color = 'danger';
        }
        zones.push(
          <lar-list-item>
            <div slot="start" class="circle">
              <lar-icon icon={zone.type} color={color} />
            </div>
            <div>
              <h4>
                <lar-translate t={zone.name} />
              </h4>
              <lar-badge color={color}>
                  <lar-translate t={'area.zone_state.' + zone.state} />
                </lar-badge>
              {zone.overridden &&
                <span>&nbsp;<lar-badge color="danger"><lar-translate t={'area.zone_state.bypassed'} /></lar-badge></span>
              }
            </div>
          </lar-list-item>
        );
      });
    });
    return <div class="zone-list">{zones}</div>;
  }
}